import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';
import { invalidateApprovalsEntriesQuery, invalidateApprovalsTimesheetsQuery, } from './query';
export const useInvalidateGetApprovalEntries = () => {
    const client = useQueryClient();
    return useCallback(() => invalidateApprovalsEntriesQuery(client), [client]);
};
export const useInvalidateGetApprovalTimesheets = () => {
    const client = useQueryClient();
    return useCallback(() => invalidateApprovalsTimesheetsQuery(client), [client]);
};
//# sourceMappingURL=use-query.js.map